import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class VideoPlayer {
	constructor(section) {
		this.section = section;
		this.video = section.querySelector('.video-player');
		this.controls = section.querySelector('.video-controls');
		this.toggleBtn = section.querySelector('.js-video-toggle');
		this.muteBtn = section.querySelector('.js-video-mute');
		this.fullscreenBtn = section.querySelector('.js-video-fullscreen');

		this.init();
	}

	init() {
		gsap.set([this.video, this.controls], { autoAlpha: 0 });

		this.tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.section,
				start: 'top 60%',
				once: true,
			},
			defaults: { ease: 'expo.out', force3D: true },
		});

		this.tl
			.to(this.video, { autoAlpha: 1, duration: 1.2, ease: 'power3.inOut', onStart: () => this.video.play() })
			.to(this.controls, { autoAlpha: 1, duration: 1 }, '<50%');

		this.toggleBtn.addEventListener('click', () => {
			if (this.video.paused) {
				this.video.play();
				this.toggleBtn.classList.remove('is-paused');
				this.toggleBtn.setAttribute('aria-label', 'Stop video');
			} else {
				this.video.pause();
				this.toggleBtn.classList.add('is-paused');
				this.toggleBtn.setAttribute('aria-label', 'Play video');
			}
		});

		this.muteBtn.addEventListener('click', () => {
			this.video.muted = !this.video.muted;
			this.muteBtn.classList.toggle('is-unmuted', !this.video.muted);
			this.muteBtn.setAttribute('aria-label', this.video.muted ? 'Unmute video' : 'Mute video');
		});

		this.fullscreenBtn.addEventListener('click', () => {
			if (this.video.requestFullscreen) {
				this.video.requestFullscreen();
			} else if (this.video.webkitEnterFullscreen) {
				this.video.webkitEnterFullscreen();
			}
		});
	}
}
